import React from "react";
import ReactDOM from "react-dom";
import "./content/css/filtersearch.css";
import "./content/css/style.css";
import { App } from "./components/App";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-colreorder";

import "jquery-ui-bundle";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

//** react slider css
import "react-slideshow-image/dist/styles.css";

import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";

import { BrowserRouter as Router } from "react-router-dom";
import { render } from "react-dom";

import "datatables.net-select";

const store = configureStore();

render(
  <ReduxProvider store={store}>
    <Router>
      <App />
    </Router>
  </ReduxProvider>,
  document.getElementById("root")
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );
